
export class PatternMatchers {
  static readonly PLATFORM_DISPUTE_INDICATORS = [
    /dispute.*with.*platform/i,
    /complain.*about.*platform/i,
    /platform.*policy/i,
    /platform.*protection/i,
    /report.*to.*platform/i,
    /platform.*refund/i,
    /marketplace.*dispute/i,
    /contact.*ebay.*customer.*service/i,
    /contact.*vinted.*customer.*service/i,
    /contact.*mercari.*customer.*service/i,
    /contact.*platform.*customer.*service/i,
    /platform.*customer.*support/i,
    /marketplace.*customer.*support/i,
    /file.*complaint.*with.*platform/i,
    /escalate.*to.*platform.*support/i,
    /platform.*support.*team/i,
    /marketplace.*support.*team/i,
    /official.*platform.*support/i
  ];

  static readonly SELLER_DIRECT_INDICATORS = [
    /contact.*seller/i,
    /message.*seller/i,
    /reach out.*seller/i,
    /talk.*seller/i,
    /communicate.*seller/i,
    /private seller/i,
    /individual seller/i,
    /seller.*directly/i,
    /seller.*personally/i,
    /bought.*from.*seller/i,
    /purchased.*from.*seller/i
  ];

  static readonly PLATFORM_MEDIATED_INDICATORS = [
    /through.*platform/i,
    /via.*platform/i,
    /platform.*message/i,
    /marketplace.*system/i,
    /official.*channel/i,
    /resolution.*center/i,
    /buyer.*protection/i
  ];

  static matchesPlatformDisputeIndicators(searchText: string): boolean {
    return this.PLATFORM_DISPUTE_INDICATORS.some(pattern => pattern.test(searchText));
  }

  static matchesSellerDirectIndicators(searchText: string): boolean {
    return this.SELLER_DIRECT_INDICATORS.some(pattern => pattern.test(searchText));
  }

  static matchesPlatformMediatedIndicators(searchText: string): boolean {
    return this.PLATFORM_MEDIATED_INDICATORS.some(pattern => pattern.test(searchText));
  }
}
